/* cf-spec-groups.js — commande « tout déplier » sur le tableau de specs.

   Amélioration pure (docs/06 §5) : les groupes sont des `<details>` natifs,
   ouvrables au clavier et à la souris sans une ligne de JavaScript. Ce fichier
   n'ajoute qu'un bouton global, injecté par le script — il n'existe donc pas
   quand le script ne tourne pas, et rien n'est perdu.

   Une responsabilité, un fichier. */

class CfSpecGroups extends HTMLElement {
  connectedCallback() {
    this.groups = Array.from(this.querySelectorAll('details'));
    if (this.groups.length < 2) return;

    this.toggle = document.createElement('button');
    this.toggle.type = 'button';
    this.toggle.className = 'cf-specs__toggle-all';
    this.onClick = this.onClick.bind(this);
    this.toggle.addEventListener('click', this.onClick);

    this.sync();
    this.prepend(this.toggle);

    this.onGroupToggle = this.sync.bind(this);
    this.groups.forEach((group) => group.addEventListener('toggle', this.onGroupToggle));
  }

  disconnectedCallback() {
    if (this.toggle) this.toggle.removeEventListener('click', this.onClick);
    if (this.onGroupToggle) {
      this.groups.forEach((group) => group.removeEventListener('toggle', this.onGroupToggle));
    }
  }

  get allOpen() {
    return this.groups.every((group) => group.open);
  }

  /* Les deux libellés viennent des locales, posés en attributs par la section :
     le script ne compose aucun texte. */
  sync() {
    const label = this.allOpen ? this.dataset.labelCollapse : this.dataset.labelExpand;
    if (label) this.toggle.textContent = label;
    this.toggle.setAttribute('aria-expanded', String(this.allOpen));
  }

  onClick() {
    const shouldOpen = !this.allOpen;
    this.groups.forEach((group) => {
      group.open = shouldOpen;
    });
    this.sync();
  }
}

if (!customElements.get('cf-spec-groups')) {
  customElements.define('cf-spec-groups', CfSpecGroups);
}
